import { frontendURL } from '../../../../helper/URLHelper';
import {
  PROFILE_SETTINGS_SECTIONS,
  profileSettingsSectionForHash,
} from '../config/settingsCenter';

const SettingsContent = () => import('../Wrapper.vue');
const Index = () => import('./Index.vue');
const PROFILE_SETTINGS_ROLES = ['administrator', 'agent'];

const legacyProfileRouteLocation = (to) => {
  const section = profileSettingsSectionForHash(to.hash);
  return {
    name: section.routeName,
    params: to.params,
    query: to.query,
  };
};

const redirectLegacyProfileHash = (to) =>
  to.hash ? legacyProfileRouteLocation(to) : true;

const buildProfileSettingsRoute = (section) => ({
  path: frontendURL(`accounts/:accountId/settings/${section.path}`),
  name: section.parentRouteName,
  roles: PROFILE_SETTINGS_ROLES,
  component: SettingsContent,
  props: {
    headerTitle: section.labelKey,
    icon: section.icon,
  },
  children: [
    {
      path: '',
      name: section.routeName,
      component: Index,
      roles: PROFILE_SETTINGS_ROLES,
      props: { section: section.key },
      ...(section.key === 'profile'
        ? { beforeEnter: redirectLegacyProfileHash }
        : {}),
    },
  ],
});

export default {
  routes: [
    ...PROFILE_SETTINGS_SECTIONS.map(buildProfileSettingsRoute),
    {
      path: frontendURL('accounts/:accountId/profile/settings'),
      name: 'profile_settings_legacy',
      roles: PROFILE_SETTINGS_ROLES,
      redirect: legacyProfileRouteLocation,
    },
  ],
};
